export enum CompanySubmodulesNames {
  legalRegister = 'legalRegister',
  legalRequirements = 'legalRequirements',
  legalChanges = 'legalChanges'
}
